import { jsx as c, jsxs as s } from "../../_virtual/jsx-runtime.mjs";
import * as o from "react";
import "../../assets/css/font.css.ts.vanilla.mjs";
import { fontColor as C } from "../../assets/css/color.mjs";
import { w as y } from "../../packages/utils/dist/useIntersectionObserver-1ee6520e.mjs";
import { multipleIcon as h, item as A, active as S, itemTile as x, content as g } from "./css/ReoAccordion.mjs";
import M from "../ReoIcon/ReoIcon.mjs";
import i from "../../depend/classnames/index.mjs";
import { getValByDef as n } from "../../utils/getValByDef.mjs";
import { ANIMATION_TIME as H, defaultProps as z } from "./const.mjs";
import { LoopIcon as T } from "./Icons.mjs";
const R = (e) => {
  const a = o.useRef(null), u = o.useRef(null);
  o.useEffect(() => {
    const t = a.current;
    if (!t)
      return;
    let l;
    if (e.active)
      requestAnimationFrame(() => {
        t.style.maxHeight = `${t.scrollHeight}px`, l = setTimeout(() => {
          t.style.maxHeight = "unset";
        }, H);
      });
    else {
      if (t.scrollHeight === 0)
        return;
      t.style.maxHeight = `${t.scrollHeight}px`, requestAnimationFrame(() => {
        t.style.maxHeight = "0";
      });
    }
    return () => {
      clearTimeout(l);
    };
  }, [e.active]);
  const r = o.useCallback((t) => {
    var l;
    (l = e.onClick) == null || l.call(e, e.value, t);
  }, [e]), m = o.useMemo(
    () => e.active ? n(e.iconActiveColor, C.active100) : n(e.iconColor, C.normal400),
    [e.active, e.iconActiveColor, e.iconColor]
  ), f = o.useMemo(() => e.loop ? /* @__PURE__ */ c(
    T,
    {
      loopIconColor: e.loopIconColor,
      loopIconActiveColor: e.loopIconActiveColor,
      loopIconCircleColor: e.loopIconCircleColor,
      loopIconCircleActiveColor: e.loopIconCircleActiveColor,
      loopGap: e.loopGap,
      active: e.active,
      iconSize: e.iconSize,
      loopSize: e.loopSize,
      loopIconClassName: e.loopIconClassName,
      loopIconCircleClassName: e.loopIconCircleClassName
    }
  ) : e.titleIcon instanceof Function ? e.titleIcon(e.active) : e.titleIcon ?? /* @__PURE__ */ c(
    M,
    {
      className: i(h, e.iconClassName),
      color: m,
      width: n(e.iconSize, z.iconSize),
      name: "icon-cross2"
    }
  ), [m, e]), I = o.useMemo(() => i(
    A,
    e.active ? S : null,
    e.itemClassName
  ), [e.active, e.itemClassName]), v = o.useMemo(() => i(
    x,
    e.titleClassName
  ), [e.titleClassName]), N = o.useMemo(() => i(
    g,
    e.contentClassName
  ), [e.contentClassName]), d = o.useMemo(
    () => ({
      ...e.contentStyle
    }),
    [e.contentStyle]
  );
  return /* @__PURE__ */ s(
    "div",
    {
      className: I,
      style: e.itemStyle,
      ref: u,
      children: [
        /* @__PURE__ */ s(
          "div",
          {
            className: v,
            style: e.titleStyle,
            onClick: r,
            children: [
              e.title,
              f
            ]
          }
        ),
        /* @__PURE__ */ c(
          "div",
          {
            className: N,
            style: d,
            ref: a,
            children: e.content
          }
        )
      ]
    }
  );
}, D = y(R, {});
export {
  D as default
};
//# sourceMappingURL=AccordionItem.mjs.map
